module["exports"] = ["#{street_prefix} #{Name.first_name}", "#{street_prefix} #{Name.last_name}"];